import React from 'react';
import useFirestoreData from '../hooks/useFirestoreData';
import './UsersList.css';

const UsersList = () => {
    const { data: users, loading, error } = useFirestoreData('users');

    if (loading) return <div style={{ padding: 20 }}>Loading users...</div>;
    if (error) return <div style={{ padding: 20 }}>Failed to load users</div>;

    return (
        <div className="users-list">
            {users.length === 0 ? (
                <div className="empty">No users found</div>
            ) : (
                users.map(u => (
                    <div key={u.id} className="user-card">
                        <img src={u.photoURL || '/favicon.ico'} alt={u.name || u.displayName} className="user-avatar" />
                        <div className="user-info">
                            <div className="user-name">{u.name || u.displayName || 'Unknown'}</div>
                            <div className="user-email">{u.email || ''}</div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default UsersList;
